<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">远程双录:</div>
        <div class="item-box-title">
          投资者在待合同签署阶段发起远程双录，对和理财师视频对话进行录音录像。
          双录结束后进行提交上传双录文件。可以投资者自己结束双体提交，也可理财师进行结束提交。
        </div>
        <div class="item-box-slide">
          <cube-slide :initialIndex="slideNorIndex" :showDots="false" :autoPlay="false" @change="slideNorChange">
            <cube-slide-item>
              <img src="~@/assets/record1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/record2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideNorIndex + 1}`}}</span>/02
            </div>
            <div class="item-box-slide-desc-text">{{['发起双录', '录制完成'][slideNorIndex]}}</div>
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="item-box">
        <div style="font-size:13px; color:#222;padding:0 0 10px 0;">本地双录:</div>
        <div class="item-box-title">
          在待投资者合同签署阶段，由理财师发起本地双录，
          投资者和理财师同框进行录音、录像。由理财师结束录制上传双录文件
        </div>
        <div class="item-box-slide">
          <cube-slide :initialIndex="slideIndex" :showDots="false" :autoPlay="false" @change="slideChange">
            <cube-slide-item>
              <img src="~@/assets/record_local1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/record_local2.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideIndex + 1}`}}</span>/02
            </div>
            <div class="item-box-slide-desc-text">
              {{['发起双录', '录制完成'][slideIndex]}}
            </div>
            <div @click="$_jumpSlideItem(slideIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideNorIndex: 0,
      slideIndex: 0,
    };
  },
  methods: {
    slideChange(index) {
      this.slideIndex = index;
    },
    slideNorChange(index) {
      this.slideNorIndex = index;
    },
    $_jumpSlideItem(index) {
      this.slideIndex = index === 0 ? 1 : 0;
    },
    $_jumpSlideItemNor(index) {
      this.slideNorIndex = index === 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  margin-bottom: 30px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
    line-height: 18px;
    span {
      color: #FF9800;
    }
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
        font-size: 15px;
      }
    }
  }
}
</style>
